import { render } from "./banner-button-v2.vue?vue&type=template&id=6fc511ad"
import script from "./banner-button-v2.vue?vue&type=script&lang=js"
export * from "./banner-button-v2.vue?vue&type=script&lang=js"

import "./banner-button-v2.vue?vue&type=style&index=0&id=6fc511ad&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/banner-button-v2.vue'],['render',render],['__file',"banner-button-v2.vue"]])

export default __exports__